import { Injectable, OnDestroy } from "@angular/core";
import { CmsComponent, CmsService, EventService } from "@spartacus/core";
import { take, tap } from "rxjs/operators";
import { Observable, Subscription } from "rxjs";
import { EcommerceType } from "../../cart/CartEvents.model";
import { CustomPromotionEvent } from "./custom-cms-events";
import { CustomCleanEcommerceEvent } from "../../common/custom-common.event";


@Injectable({
  providedIn: 'root',
})
export class CustomCmsEventService implements OnDestroy {

  private subscriptions: Subscription = new Subscription();

  constructor(protected eventService: EventService,
              protected cmsService: CmsService) {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  dispatchViewPromotionEvent(components: CmsComponent[]) {
    this.dispatchPromotionEvent(components, EcommerceType.VIEW_PROMOTION);
  }

  dispatchSelectPromotionEvent(components: CmsComponent[]) {
    this.dispatchPromotionEvent(components, EcommerceType.SELECT_PROMOTION);
  }

  private dispatchPromotionEvent(
    components: CmsComponent[],
    eventType: EcommerceType,
  ) {
    if (components.length <= 0) {
      return;
    }
    this.dispatchCleanEcommerceEvent();
    const slotName = this.getSlotName(components[0]?.['parents']);

    this.eventService.dispatch<CustomPromotionEvent>(
      this.buildPromotionEventData<CustomPromotionEvent>(
        components,
        eventType,
        slotName
      ),
      CustomPromotionEvent
    );
  }

  private buildPromotionEventData<T>(
    components: CmsComponent[],
    event: EcommerceType,
    slotName: string
  ): CustomPromotionEvent {
    return {
      event: event,
      ecommerce: {
        items: components.map((component: CmsComponent) => ({
          creative_name: component?.name ?? '',
          creative_slot: slotName,
          promotion_id: component?.uid ?? '',
          promotion_name: component?.name ?? '',
          promotion_brand: '',
        }))

      },
    };
  }

  private dispatchCleanEcommerceEvent() {
    this.eventService.dispatch<CustomCleanEcommerceEvent>(
      {ecommerce: null} as CustomCleanEcommerceEvent,
      CustomCleanEcommerceEvent
    );
  }

  private getSlotName(componentId: string): string {
    let slotName = '';
    this.subscriptions.add(
      this.cmsService
        .getCurrentPage()
        .pipe(
          take(1),
          tap(page => {
            for (const slot in page.slots) {
              if (page.slots[slot].components?.find(data => data.uid === componentId)) {
                slotName = slot;
                break;
              }
            }
          })
        ).subscribe()
    );
    return slotName;
  }

  getComponentList(cmsComponents$: Observable<CmsComponent>[]): CmsComponent[] {
    const cmsItemComponents: CmsComponent[] = [];
    cmsComponents$.forEach((cmsComponent) => {
      this.subscriptions.add(
        cmsComponent.subscribe((componentData) => {
          cmsItemComponents.push(componentData);
        })
      )
    });
    return cmsItemComponents
  }

  getSelectedComponent(cmsComponent$: Observable<CmsComponent>): CmsComponent[] {
    const cmsItemComponents: CmsComponent[] = [];
    this.subscriptions.add(
      cmsComponent$.subscribe((componentData) => {
        cmsItemComponents.push(componentData);
      })
    )
    return cmsItemComponents
  }
}
